export enum DataTypeEnum {
  ValueSelect,
  String,
  DateTime,
  Boolean,
  Number,
}

export const DataTypeText = [
  "Available value",
  "String",
  "Date time",
  "Boolean",
  "Number",
];
